import * as React from 'react';
import { SVGProps } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    viewBox="0 0 40 40"
    {...props}
  >
    <mask
      id="beamMask"
      width={38}
      height={38}
      x={1}
      y={1}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <circle cx={20} cy={20} r={18.333} fill="#D9D9D9" />
    </mask>
    <g mask="url(#beamMask)">
      <path fill="#4066C9" d="M1.667 1.667h36.667v9.167H1.667z" />
      <path fill="#EC450D" d="M1.667 10.833h36.667V20H1.667z" />
      <path fill="#10A35D" d="M1.667 29.167h36.667v9.167H1.667z" />
      <path fill="#FFA50A" d="M1.667 20h36.667v9.167H1.667z" />
    </g>
  </svg>
);
export default SvgComponent;
